/* src/app/layout/main-layout/notpad-modal/notpad-modal.component.scss */
.cdk-overlay-container {
  display: none !important;
}
.cdk-global-overlay-wrapper {
  pointer-events: none;
  top: 107px !important;
  left: 0;
  width: 65% !important;
}
:host ::ng-deep .ck-editor__editable_inline {
  min-height: 250px !important;
}
.cke_top {
  border-radius: 10px 10px 0px 0px;
}
.cke_bottom {
  border-radius: 0px 0px 10px 10px;
}
.demo-update {
  border: 1px solid var(--ck-color-base-border);
  border-radius: var(--ck-border-radius);
  box-shadow: 2px 2px 0px hsla(0, 0%, 0%, 0.1);
  margin: 1.5em 0;
  padding: 1em;
}
.demo-update h3 {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 0.5em;
  padding: 0;
}
.demo-update__controls {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.demo-update__chart {
  margin-right: 1em;
}
.demo-update__chart__circle {
  transform: rotate(-90deg);
  transform-origin: center;
}
.demo-update__chart__characters {
  font-size: 13px;
  font-weight: bold;
}
.demo-update__words {
  flex-grow: 1;
  opacity: 0.5;
}
.demo-update__limit-close .demo-update__chart__circle {
  stroke: hsl(30, 100%, 52%);
}
.demo-update__limit-exceeded .demo-update__chart__circle {
  stroke: hsl(0, 100%, 52%);
}
.demo-update__limit-exceeded .demo-update__chart__characters {
  fill: hsl(0, 100%, 52%);
}
/*# sourceMappingURL=notpad-modal.component.css.map */
